import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface PaletteOptions {
    uploadFile?: {
      dragOver?: string;
    };
  }
}

const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: 'rgb(177, 208, 138)',
    },
    secondary: {
      main: 'rgb(33, 181, 136)',
    },
    background: {
      default: '#ffffff',
      paper: '#f5f5f5',
    },
    user: {
      main: '#1976d2',
    },
    family: {
      main: '#4caf50',
    },
    userList: {
      selected: '#d0d0d0',
      hover: '#d0d0d0',
    },
    uploadFile: {
      dragOver: '#e0f7fa', // New color definition
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "*": {
          scrollbarWidth: "thin", // For Firefox
        },
        "*::-webkit-scrollbar": {
          width: "8px",
        },
        "*::-webkit-scrollbar-thumb": {
          backgroundColor: "#1976d2",
          borderRadius: "4px",
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent", // צבע רקע של פס ההתקדמות
        //  backgroundColor: "hsl(220, 20%, 88%);", // צבע רקע של פס ההתקדמות
          borderRadius: "5px",
        },
        bar: {
          borderRadius: "5px", // קצוות מעוגלים לפס ההתקדמות
        },
      },
    },
  
  },
});

export default lightTheme;
